export { default as FireIcon } from "./FireIcon";
